import {AnalyticsProvider} from '@github-ui/analytics-provider'
import type {LayoutPayload} from '@github-ui/code-view-types'
import {CurrentRepositoryProvider} from '@github-ui/current-repository'
import {CurrentUserProvider} from '@github-ui/current-user'
import {FocusHintContextProvider} from '@github-ui/focus-hint-context'
import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
// eslint-disable-next-line no-restricted-imports
import {ScreenSize, ScreenSizeProvider} from '@github-ui/screen-size'
import {CodeViewOptionsProvider} from '@github-ui/use-code-view-options'
import React, {useEffect, useMemo} from 'react'

export function App({children}: {children?: React.ReactNode}) {
  const payload = useRoutePayload<LayoutPayload>()

  return <AppWrapper payload={payload}>{children}</AppWrapper>
}

export function AppWrapper({children, payload}: {children?: React.ReactNode; payload: LayoutPayload}) {
  const [repo] = React.useState(payload?.repo)
  const [user] = React.useState(payload?.currentUser)
  const appName = 'react-code-view'
  const category = ''
  const metadata = useMemo(() => ({}), [])

  useEffect(() => {
    const footer = document.querySelector('.footer')
    if (footer) {
      footer.querySelector('.mt-6')?.classList.replace('mt-6', 'mt-0')
      footer.querySelector('.border-top')?.classList.remove('border-top')
    }
  }, [])

  return (
    <>
      {/*
       *React hoists this meta tag to the <head> ensuring that we have one, even if turbo wouldn't add one.
       * We should still set this on the server though, to ensure that stats can be collected before hydration
       * as well.
       */}
      <meta name="github-code-view-meta-stats" id="github-code-view-meta-stats" data-hydrostats="publish" />
      <ScreenSizeProvider initialValue={ScreenSize.xxxlarge}>
        <AnalyticsProvider appName={appName} category={category} metadata={metadata}>
          <CurrentUserProvider user={user}>
            <CurrentRepositoryProvider repository={repo}>
              <CodeViewOptionsProvider>
                <FocusHintContextProvider>{children}</FocusHintContextProvider>
              </CodeViewOptionsProvider>
            </CurrentRepositoryProvider>
          </CurrentUserProvider>
        </AnalyticsProvider>
      </ScreenSizeProvider>
    </>
  )
}

try{ App.displayName ||= 'App' } catch {}
try{ AppWrapper.displayName ||= 'AppWrapper' } catch {}